module.exports = __webpack_public_path__ + "02_short_black.793e7fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_short_black.png
// module id = 7QM9
// module chunks = 0